import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";

type FormBuilderCancelButton = {
	form: any;
	handleFormCancel: () => void;
	/** When true the button is always clickable; the discard confirmation only
	 *  appears when the form has unsaved changes. */
	alwaysEnabled?: boolean;
	isLoading?: boolean;
};

const FormButtonCancelButton = ({
	form,
	handleFormCancel,
	alwaysEnabled = false,
	isLoading = false,
}: FormBuilderCancelButton) => {
	const hasUnsavedChanges = form.isDirty;

	return (
		<Popconfirm
			icon={<ExclamationCircleOutlined style={{ color: "grey" }} />}
			title={
				<div style={{ maxWidth: "300px", padding: "10px" }}>
					<>You have unsaved changes. Discard them or continue editing?</>
				</div>
			}
			placement="topRight"
			cancelButtonProps={{ ghost: true }}
			cancelText="Discard changes"
			onCancel={handleFormCancel}
			okText="Continue editing"
			okType="default"
			disabled={(alwaysEnabled && !hasUnsavedChanges) || isLoading}
		>
			<Button
				className="ant-btn-secondary"
				disabled={(!alwaysEnabled && !hasUnsavedChanges) || isLoading}
				onClick={() => {
					if (!hasUnsavedChanges) {
						handleFormCancel();
					}
				}}
			>
				{hasUnsavedChanges ? "Cancel" : "Close"}
			</Button>
		</Popconfirm>
	);
};

export default FormButtonCancelButton;
